<script setup lang="ts">
import ModalComponent from '@/components/ModalComponent.vue'
import { serviceDescriptor } from '@/config/services'
import { Request } from '@/modules/trips/interfaces/cef'

defineProps<{
	modelValue: boolean
	linkedRequests: Request[]
}>()

const emit = defineEmits<{
	(e: 'update:modelValue', value: boolean): void
	(e: 'confirm'): void
	(e: 'cancel'): void
}>()

// Del registry. El ternario anterior solo cubría Plane y Hotel: un auto o un
// autobús caían al icono de maleta (`luggage`).
const serviceIcon = (serviceName: string | null | undefined) =>
	serviceDescriptor(serviceName).icon
</script>

<template>
	<ModalComponent
		:model-value="modelValue"
		@update:model-value="emit('update:modelValue', $event)"
	>
		<template #modalBody>
			<div class="h-1.5 bg-gradient-to-r from-amber-400 to-orange-400" />

			<div class="p-6">
				<div class="mb-4 flex flex-col items-center text-center">
					<div
						class="mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-amber-100"
					>
						<span class="material-symbols-outlined text-[28px] text-amber-600"
							>link_off</span
						>
					</div>
					<h3 class="text-base font-bold text-gray-900">
						Desvinculación de itinerario
					</h3>
					<p class="mt-1 text-sm text-gray-500">
						Al modificar el socio o los viajeros, el siguiente itinerario
						quedará desvinculado de esta solicitud.
					</p>
				</div>

				<div
					class="mb-5 divide-y divide-amber-100 overflow-hidden rounded-xl border border-amber-200 bg-amber-50"
				>
					<div
						v-for="req in linkedRequests"
						:key="req.id"
						class="flex items-center gap-3 px-3.5 py-2.5"
					>
						<div
							class="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-amber-100"
						>
							<span class="material-symbols-outlined text-[15px] text-amber-600">
								{{ serviceIcon(req.serviceName) }}
							</span>
						</div>
						<div class="min-w-0 flex-1">
							<p class="truncate text-sm font-semibold text-gray-800">
								<template v-if="req.serviceName === 'Plane'">
									{{ req.originAirport?.iataCode ?? req.origin }}
									→
									{{ req.destinationAirport?.iataCode ?? req.destination ?? '—' }}
								</template>
								<template v-else>{{ req.suppliableName }}</template>
							</p>
							<p class="text-[11px] text-gray-400">
								{{ req.suppliableName }} · {{ req.serviceName }}
							</p>
						</div>
					</div>
				</div>

				<div class="flex items-center gap-2">
					<button
						class="w-full rounded-xl bg-white px-4 py-2.5 text-sm font-semibold border-2 border-gray-900 text-gray-800 hover:bg-gray-200 shadow-sm transition-colors"
						@click.prevent="emit('cancel')"
					>
						Cancelar
					</button>

					<button
						type="button"
						class="w-full rounded-xl bg-amber-500 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-amber-600"
						@click.prevent="emit('confirm')"
					>
						Entendido
					</button>
				</div>
			</div>
		</template>
	</ModalComponent>
</template>
